import { render, staticRenderFns } from "./teamInfo.vue?vue&type=template&id=913dcd40&scoped=true"
import script from "./teamInfo.vue?vue&type=script&lang=js"
export * from "./teamInfo.vue?vue&type=script&lang=js"
import style0 from "./teamInfo.vue?vue&type=style&index=0&id=913dcd40&prod&scoped=scoped&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "913dcd40",
  null
  
)

export default component.exports